import { Injectable } from '@angular/core';
// The 'ShortNumberInfo' is missing in the original type definition of the 'google-libphonenumber' library.
// Therefore, we need to have a custom oa-module but TS can not find it by default. To avoid the TS error, we are using @ts-ignore here.
// @ts-ignore
import {PhoneNumber, PhoneNumberFormat, PhoneNumberType, PhoneNumberUtil, ShortNumberInfo} from 'google-libphonenumber';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {
  private phoneNumberUtil = PhoneNumberUtil.getInstance();
  
  constructor() { }
  
  
  public checkValidNumber(countryPrefix: string, number: string): boolean {
    if (!countryPrefix || !number || number.length <= 0) {
      return false;
    }
    const phoneNumber = this.getFullTrimmedNumber( countryPrefix, number);
    try {
      const phoneNumberParsed = this.phoneNumberUtil.parseAndKeepRawInput(phoneNumber, 'DE');
      return this.phoneNumberUtil.isValidNumber(phoneNumberParsed);
    } catch (e) {
    
    }
    return false;
  }
  
  public getNationalNumber(countryPrefix: string, number: string): string | undefined {
    if (!this.checkValidNumber(countryPrefix, number)) {
      return;
    }
    const phoneNumber =  this.getFullTrimmedNumber( countryPrefix, number);
    try {
      const phoneNumberParsed = this.phoneNumberUtil.parseAndKeepRawInput(phoneNumber, 'DE');
      return phoneNumberParsed.getNationalNumber()?.toString();
    } catch (e) {
      return;
    }
  }
  
  private getFullTrimmedNumber(prefix: string, number: string): string {
    const fullNumber = prefix.concat(number);
    return fullNumber.trim().replace(/\s+/g, '');
  }
}
